import { useEffect, useState } from 'react'

import Button from 'common/components/button'
import Modal from 'common/components/Modal'
import TextArea from 'common/components/textarea'

import ItemInfoDisplay from './ItemInfoDisplay'

type Props = {
  isOpen: boolean
  onClose: () => void
  onSave: (newDescription: string) => void
  itemInfo: {
    id: string
    name: string | undefined
    path: string[]
    type: 'product' | 'category'
  }
  initialDescription: string | undefined
  isLoading: boolean
}

const EditDescriptionModal = ({
  isOpen,
  onClose,
  onSave,
  itemInfo,
  initialDescription,
  isLoading,
}: Props) => {
  const [description, setDescription] = useState(initialDescription ?? '')

  useEffect(() => {
    if (isOpen) {
      setDescription(initialDescription ?? '')
    }
  }, [isOpen, initialDescription])

  const handleSave = () => {
    onSave(description)
  }

  return (
    <Modal visible={isOpen} onClose={onClose} centered closable={false}>
      <div className="flex flex-col gap-6">
        <div className="text-base-700 text-2xl font-medium break-words">
          Update description
        </div>
        <div className="flex flex-col gap-4 min-w-200">
          <ItemInfoDisplay
            id={itemInfo.id}
            name={itemInfo.name}
            path={itemInfo.path}
            type={itemInfo.type}
          />
          <TextArea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            rows={5}
            maxLength={1000}
            placeholder="Enter description..."
            disabled={isLoading}
          />
        </div>
        <div className="flex justify-end gap-4 mt-6">
          <Button variant="link" onClick={onClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleSave}
            loading={isLoading}
            disabled={
              isLoading ||
              description.trim() === '' ||
              description.trim() === initialDescription?.trim()
            }
          >
            Save
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default EditDescriptionModal
